import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { NetworkStatus } from '../../providers/network/network';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'network-status',
  styleUrls: ['./network-status.component.scss'],
  standalone: true,
  imports: [TranslateModule],
  templateUrl: 'network-status.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NetworkStatusComponent {
  networkStatus = input<NetworkStatus>(null);

  networkStateColor = computed(() => {
    const colors = {
      [NetworkStatus.ONLINE]: '#4F9E30',
      [NetworkStatus.OFFLINE]: '#FE0000',
      [NetworkStatus.DEGRADED]: '#666666',
    };
    return this.networkStatus() ? colors[this.networkStatus()!] : '';
  });

  networkStateText = computed(() => {
    const texte = {
      [NetworkStatus.ONLINE]: 'NETWORK_STATUS.ONLINE',
      [NetworkStatus.OFFLINE]: 'NETWORK_STATUS.OFFLINE',
      [NetworkStatus.DEGRADED]: 'NETWORK_STATUS.DEGRADED',
    };
    return this.networkStatus() ? texte[this.networkStatus()!] : '';
  });
}
